/**
 * Standard date/time cell for the data grids across the app.
 *
 * Formats a timestamp with the viewing user's locale date+time preferences and
 * renders it through GridTextCell, so an empty timestamp shows the same em-dash
 * placeholder a blank text cell does. This is the house presentation for a
 * timestamp column that follows the user's format setting — grids with bespoke
 * timezone or relative-time needs keep their own formatting.
 *
 * Contains:
 * - GridDateCell — presentational user-formatted timestamp grid cell (default export)
 */

import PropTypes from 'prop-types';
import React from 'react';

import { formatDateTime } from '@sophocles/utils/formatUtils';

import GridTextCell from './GridTextCell';

/**
 * @param {object} props
 * @param {string|Date} [props.value] - the timestamp; empty/nullish renders an em-dash.
 * @param {object} [props.user] - the viewing user, for locale date/time format.
 * @returns {JSX.Element}
 */
export default function GridDateCell({ value, user }) {
  return <GridTextCell value={value ? formatDateTime(value, user) : ''} />;
}

GridDateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  user: PropTypes.object,
};
